const checkIfFiveDigits = (value:string) => {
    // Create a regular expression pattern to match exactly five digits
    const pattern = /^\d{5}$/;
  
    // Test the value against the pattern
    return pattern.test(value);
}

const form = () => {
    document.addEventListener('DOMContentLoaded', () => {
        document.querySelectorAll('[data-form]').forEach((form) => {
            const formElement = form as HTMLFormElement;
            const repeatMailInput = formElement.querySelector('#email-repeat') as HTMLInputElement;
            const mailInput = formElement.querySelector('#email') as HTMLInputElement;

            const zipCodeInput = form.querySelector('[name="zip-code"]') as HTMLInputElement;

            zipCodeInput.addEventListener('change', function (event : any) {
                const pattern = /^\d{5}$/;
                const isFiveDigits = pattern.test(event.target.value); 
                if (isFiveDigits === false) {
                    event.target.setCustomValidity('Bitte gib eine 5-stellige Postleitzahl ein');
                } else {
                    event.target.setCustomValidity('');
                }
                event.target.reportValidity();
            });

            repeatMailInput.addEventListener('change', function (event : any) {
                const mailInputValue = mailInput.value;
                const repeatMailInputValue = repeatMailInput.value;
                if (mailInputValue !== repeatMailInputValue) {
                    event.target.setCustomValidity('Die E-Mail Adressen stimmen nicht überein');
                } else {
                    event.target.setCustomValidity('');
                }
                event.target.reportValidity();
            });

            formElement.addEventListener('submit', async (event) => {
                event.preventDefault();
                try {
                    const responseToken = await fetch('/wp-json/gg/token', {
                        method: 'GET'
                    });
                    if (!responseToken.ok) throw new Error();
                    const tokenData = await responseToken.json();
                    const token = Number(tokenData.token) as number;
                    const generatedToken = token + 23;
                    const dataGeneratedTokenElem = formElement.querySelector('[data-generated-token]') as HTMLInputElement;
                    dataGeneratedTokenElem.setAttribute('value', String(generatedToken));
                    const formData = new FormData(formElement);
                    const select = form.querySelector("#select") as HTMLSelectElement;
                    const selectValue = parseInt(select.options[select.selectedIndex].value);
                    formElement.reset();
                    if(selectValue === 1) {
                        // @ts-ignore
                        if(dataLayer){
                            // @ts-ignore
                            dataLayer.push({'event': 'form_it_application'});
                        }
                    }
                    if(selectValue === 2) {
                        // @ts-ignore
                        if(dataLayer){
                            // @ts-ignore
                            dataLayer.push({'event': 'form_engineering_application'});
                        }
                    }
                    if(selectValue === 3) {
                        // @ts-ignore
                        if(dataLayer){
                            // @ts-ignore
                            dataLayer.push({'event': 'form_life_sciences_and_healthcare_application'});
                        }
                    }
                    if(selectValue === 4) {
                        // @ts-ignore
                        if(dataLayer){
                            // @ts-ignore
                            dataLayer.push({'event': 'form_sales_and_recruiting_application'});
                        }
                    }
                    if(selectValue === 5) {
                        // @ts-ignore
                        if(dataLayer){
                            // @ts-ignore
                            dataLayer.push({'event': 'form_zentralfunktionen_application'});
                        }
                    }
                    if(selectValue === 6) {
                        // @ts-ignore
                        if(dataLayer){
                            // @ts-ignore
                            dataLayer.push({'event': 'form_technisch_handwerklich_application'});
                        }
                    }
                    const response = await fetch('/wp-json/gg/form/' + selectValue, {
                        method: 'POST',
                        body: formData
                    });
                    const data = await response.json();
                    if (!response.ok) throw new Error();
                    if (data===true) {
                        const formErrorElement = document.querySelector("#form-error") as HTMLElement;
                        formErrorElement.style.display = "none";
                        const formSuccessElement = document.querySelector("#form-success") as HTMLElement;
                        formSuccessElement.style.display = "block";
                        formSuccessElement.scrollIntoView({block:"center",behavior: 'smooth'});
                    } else {
                        throw new Error();
                    }
                } catch (error) {
                    const formSuccessElement = document.querySelector("#form-success") as HTMLElement;
                    formSuccessElement.style.display = "none";
                    const formErrorElement = document.querySelector("#form-error") as HTMLElement;
                    formErrorElement.style.display = "block";
                    formErrorElement.scrollIntoView({block:"center",behavior: 'smooth'});
                }
            });
        });
    });
}

export { form }